// import Vue from 'vue'
import { Component, Watch } from "vue-property-decorator";
import baseUserContextPage from "../baseUserContextPage";
import axios from "axios";
import { ImportRequest, SisasImportItem } from "@/models/importModels";
import { pagedList, sortDirection } from "@/models/pagedList";

@Component({})
export default class importPage extends baseUserContextPage {
  isLoading: boolean = false;
  showPanelEseguiImport: boolean = true;
  showImportDetailModal: boolean = false;
  currentSisasImport: SisasImportItem = null;
  importRequest: ImportRequest = new ImportRequest();
  list: pagedList<SisasImportItem> = new pagedList();
  searchParams: any = {
    pageSize: 20,
    pageIndex: 0,
    search: null,
    orderField: "dataCreazione",
    direction: sortDirection.DESC,
  };
  updateQueryParams(): void {
    var instance = this;
    instance.$router.push({
      name: "configurationImport",
      query: instance.getQueryParams()
    });
    this.fetch();
  }
  getQueryParams(): any {
    var instance = this;
    return {
      page: instance.searchParams.pageIndex,
      search: instance.searchParams.search,
      orderField: instance.searchParams.orderField,
      direction: instance.searchParams.direction
    };
  }
  setQueryParams(params: any) {
    var instance = this;
    instance.searchParams.pageIndex = params.page;
    instance.searchParams.search = params.search;
    instance.searchParams.orderField = params.orderField;
    instance.searchParams.direction = params.direction;
  }

  pageChanged(page: number) {
    this.searchParams.pageIndex = page;
    this.updateQueryParams();
  }
  onSearch() {
    this.searchParams.pageIndex = 0;
    this.updateQueryParams();
  }
  onSelect(imp: SisasImportItem) {
    this.currentSisasImport = imp;
    this.showImportDetailModal = true;
  }
  closeImportDetailModal() {
    this.showImportDetailModal = false;
    this.currentSisasImport = null;
  }
  onSort(field: string) {
    var instance = this;
    if (instance.searchParams.orderField != field) {
      instance.searchParams.orderField = field;
      instance.searchParams.direction = sortDirection.ASC;
    } else {
      instance.searchParams.direction =
        instance.searchParams.direction == sortDirection.ASC
          ? sortDirection.DESC
          : sortDirection.ASC;
    }
    instance.updateQueryParams();
    //instance.fetch();
  }
  fetch(): void {
    var instance = this;
    instance.isLoading = true;
    axios
      .get<pagedList<SisasImportItem>>("/import/search", {
        params: instance.searchParams
      })
      .then(res => {
        instance.list = res.data ? res.data : new pagedList();
        instance.isLoading = false;
      })
      .catch(error => {
        console.error(error);
        instance.isLoading = false;
      });
  }
  mounted() {
    var instance = this;
    instance.setQueryParams(instance.$route.query);
    instance.fetch();
  }
  onAllineaPrezzi() {
    var self = this;
    self.importRequest.erpListiniCondizioniCommerciali.attivo = true;
    self.importRequest.condizioniCommerciali.attivo = true;
    self.importRequest.listini.attivo = true;
  }
  schedula() {
    var self = this;
    self.setPageLoading(true);
    axios
      .post<string>(`/import/add-schedule`, self.importRequest)
      .then(res => {
        self.$notify({
          title: "",
          text: "Richiesta processata correttamente",
          type: "success",
          group: "msg"
        });
        self.fetch();
      })
      .catch(error => {

        // self.$notify({
        //   title: "",
        //   text: "Salvataggio non riuscito",
        //   type: "error",
        //   group: "msg"
        // });
      }).finally(() =>
        self.setPageLoading(false)
      );
  }
}